import Home from '../views/Home.vue';
import checkAuth from '../utils/checkAuth';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: checkAuth,
  },
  {
    path: '/order/:orderId',
    name: 'order-details',
    component: () => import(/* webpackChunkName: "main-app" */ '../views/app/order-details/'),
  },
  {
    path: '/app',
    name: 'app',
    component: () => import(/* webpackChunkName: "main-app" */ '../views/app'),
    redirect: '/app/dashboard',
    beforeEnter: checkAuth,
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: 'dashboard',
        name: 'app-dashboard',
        component: () => import(/* webpackChunkName: "app-home" */ '../views/app/home'),
      },
      {
        path: 'orderuid',
        name: 'app-orderuid',
        component: () => import(/* webpackChunkName: "app-home" */ '../views/app/orderuid'),
      },
      {
        path: 'mapped-pincode',
        name: 'app-mapped-pincode',
        component: () => import(/* webpackChunkName: "app-home" */ '../views/app/mapped-pincode'),
      },
      {
        path: 'trade-policy-users',
        name: 'trade-policy-users',
        component: () => import(/* webpackChunkName: "app-trade-policy-upload" */ '../views/app/trade-policy-users'),
        children: [
          {
            path: 'import-export',
            component: () => import(/* webpackChunkName: "app-trade-policy-import-export" */ '../views/app/trade-policy-users/ImportExport.vue'),
          },
          {
            path: 'add-user',
            component: () => import(/* webpackChunkName: "app-trade-policy-add-user" */ '../views/app/trade-policy-users/create.vue'),
          },
          {
            path: 'edit-user',
            component: () => import(/* webpackChunkName: "app-trade-policy-edit-user" */ '../views/app/trade-policy-users/edit.vue'),
          },
        ],
      },
      /* {
        path: 'channel-partners-types',
        name: 'channel-partners-types',
        component: () => import(/* webpackChunkName: "app-home"  '../views/app/channel-partners-types'),
      }, */
      {
        path: 'orders',
        component: () => import(/* webpackChunkName: "app-home" */ '../views/app/orders'),
        children: [
          {
            path: 'view',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/orders/Orders.vue'),
          },
          {
            path: 'map-pincode',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/orders/MapPincode.vue'),
          },
          {
            path: ':orderId',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/orders/Order.vue'),
          },
        ],
      },
      {
        path: 'trade-policy-agreements',
        component: () => import(/* webpackChunkName: "trade-policy-agreements" */ '../views/app/trade-policy-agreements'),
      },
      {
        path: 'asos',
        name: 'asos',
        component: () => import(/* webpackChunkName: "app-home" */ '../views/app/asos'),
        children: [
          {
            path: 'manage',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/asos/Manage.vue'),
          },
          {
            path: 'edit/:uid',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/asos/Edit.vue'),
          },
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "app-home" */ '../views/app/asos/Create.vue'),
          },
        ],
      },
      {
        path: 'map-pincode',
        component: () => import(/* webpackChunkName: "app-map-pincode" */ '../views/app/map-pincode'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "app-map-pincode" */ '../views/app/map-pincode/MapPincode.vue'),
          },
        ],
      },
    ],
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "signup" */ '../views/Login.vue'),
  },
  {
    path: '*',
    name: 'not-found-error',
    component: () => import(/* webpackChunkName: "not-found-error" */ '../components/NotFound.vue'),
  },
];

export default routes;
